import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from '@store/types';

interface DismissalsState {
  persistentDismissedIds: string[];
  sessionDismissedIds: string[];
}

const emptyDismissals: DismissalsState = {
  persistentDismissedIds: [],
  sessionDismissedIds: [],
};

// Base selector with fallback for when feature is not registered
const selectDismissalsState = (state: RootState): DismissalsState =>
  state['systemNotifications/dismissals'] || emptyDismissals;

export const selectPersistentDismissedIds = createSelector(
  [selectDismissalsState],
  (dismissals): string[] => dismissals.persistentDismissedIds,
);

export const selectSessionDismissedIds = createSelector(
  [selectDismissalsState],
  (dismissals): string[] => dismissals.sessionDismissedIds,
);
